
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, computed, reactive, onMounted, defineComponent} from 'vue';
import {useTicketStore} from '../../stores/TicketStore';
import {storeToRefs} from 'pinia'
import LoadingSpinner from "../../components/loading/LoadingSpinner.vue";
import OptionBox from "../../components/boxes/OptionBox.vue";

export default defineComponent({
    name: 'LegalDisclaimerView',
    components: {
        OptionBox,
        LoadingSpinner
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        ticketId: {
            type: String,
            required: true,
        },
        isAnnualPass: {
            type: Boolean,
            required: false,
            default: false
        },
        disclaimerOptions: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    setup(props) {
        const ticketStore = useTicketStore();
        const {
            checkedLegalDisclaimers
        } = storeToRefs(ticketStore)

        const { changeCheckedLegalDisclaimers } = ticketStore;


        const onChangeOption = (checkedOptions) => {
            console.log("onChangeOption checkedOptions", checkedOptions)
            changeCheckedLegalDisclaimers(checkedOptions)
        }

        return {
            translate,
            onChangeOption,
            checkedLegalDisclaimers
        }
    }
});
